<div class="main-section">

  <section *ngIf="this.gameConfig.sliderName === 'slider'">
    <div id="carouselExampleIndicators" class="carousel slide  hero-banner" data-bs-ride="carousel">
      <div class="carousel-indicators">
        <button type="button" *ngFor="let item of gameConfig.imageList; let i = index;" data-bs-target="#carouselExampleIndicators" attr.data-bs-slide-to="{{i}}" class="{{ (i == 0) ? 'active' : '' }}"
          attr.aria-label="Slide {{i}}"></button>

      </div>
      <div class="carousel-inner container">
        <ng-container *ngFor="let item of gameConfig.imageList; let i = index;">
        <div class="carousel-item" [ngClass]="{'active': i == 0}">
          <div class="row">
            <div class="col-lg-6  ps-lg-5 ps-0 order-1 order-lg-0">
              <div class="carousel-text">
                <h1 class="text-theme-green hero-heading">{{this.gameConfig.header1}}</h1>
                <h2 class="text-theme-green hero-sub-heading">{{this.gameConfig.header2}}</h2>
                <p>{{this.gameConfig.description}}</p>
              </div>
            </div>
            <div class="col-lg-6 text-center order-0 order-lg-1 mt-3 carousel-img">
              <img [src]="item" alt="carousel-1" class=" game-carousel" />
            </div>
          </div>
        </div>
      </ng-container>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
        data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
        data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </section>

  <section *ngIf="this.gameConfig.sliderName === 'noslider'">
    <div class="">
        <div class="container ">
            <div class="px-60">
                <div class="row">
                    <div class="col-md-6  ps-lg-5 ps-0 order-1 order-md-0">
                        <div class="carousel-text video-text">
                            <!-- <h4>{{portalName}}</h4> -->
                            <h1 class="text-theme-green hero-heading">{{this.gameConfig.header1}}</h1>
                <h2 class="text-theme-green hero-sub-heading">{{this.gameConfig.header2}}</h2>
                            <p>{{this.gameConfig.description}}</p>
                        </div>
                    </div>
                    <div class="col-md-6 text-center order-0 order-md-1 mt-3 carousel-img">
                        <div class="image-warp d-flex" *ngFor="let item of gameConfig.imageList; let i = index;">
                            <img [src]="item" class="img-fluid" alt="image" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>


  <section class="design-responsive-1" *ngIf="this.gameConfig.sliderName === 'videoSlider'">
    <div class=" hero-banner">
        <div class="container ">
            <div class="px-60">
                <div class="row">
                    <div class="col-md-6  ps-lg-5 ps-0 order-1 order-md-0">
                        <div class="carousel-text video-text">
                          <h1 class="text-theme-green hero-heading">{{this.gameConfig.header1}}</h1>
                          <h2 class="text-theme-green hero-sub-heading">{{this.gameConfig.header2}}</h2>
                          <p>{{this.gameConfig.description}}</p>                          <a href="#" class="btn btn-ghost btn-post mt-0">View</a>
                        </div>
                    </div>
                    <div class="col-md-6 text-center order-0 order-md-1 mt-3 carousel-img">
                        <div class="image-warp d-flex">
                            <div class="swiper mySwiper">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" *ngFor="let item of gameConfig.imageList; let i = index;" >
                                        <div class="image-slider img-1">
                                            <img [src]="item" alt="" class="img-fluid">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>


  <section class="mt-64 design-responsive">
      <div class="design-6">
          <img src="./../../assets/images/3.png" alt="">
      </div>
      <div class="design-7">
          <img src="./../../assets/images/4.png" alt="">
      </div>
      <div class="design-8">
          <img src="./../../assets/images/2.png" alt="">
      </div>
      <div class="design-9">
          <img src="./../../assets/images/1.png" alt="">
      </div>
      <div class="container">
          <div class="row">
              <div class="col-lg-12">
                  <div class="section-title text-center">
                      <h2>About US</h2>
                  </div>

              </div>

              <div class="col-lg-6">
                  <img src="./../../assets/images/Terra_Infirma_800x389.png" alt="" class="img-fluid">
              </div>
              <div class="col-lg-6">
                  <div class="text-white about-text">
                      <p>{{aboutus.description}}</p>
                  </div>
              </div>
          </div>
      </div>
  </section>

  <section class="mt-4">

      <div class="container">
          <div class="row">
              <div class="col-lg-6">
                  <div class="section-title text-center">
                      <h2>Mission</h2>
                  </div>
                  <div class="text-white mission-text">
                      <p>Our mission and values are to help people and businesses throughout the world realize their full potential.</p>
                  </div>
              </div>

              <div class="col-lg-6">
                  <div class="section-title text-center">
                      <h2>Vision</h2>
                  </div>
                  <div class="text-white mission-text">
                      <p>Our vision is to be earth's most customer centric company;to build a place where people can come to find any solution for their problem .</p>
                  </div>
              </div>

          </div>
      </div>
  </section>

</div>
